import React, { Component } from "react";

export class Step4Mobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appType: props.formData.appType || "",
      platform: props.formData.platform || "",
      userLogin: props.formData.userLogin || "Yes",
      adminPanel: props.formData.adminPanel || "Yes",
      paymentGateway: props.formData.paymentGateway || "No",
      pushNotification: props.formData.pushNotification || "Yes",
      gpsLocation: props.formData.gpsLocation || "No",
      chatSupport: props.formData.chatSupport || "No",
      apiIntegration: props.formData.apiIntegration || "No",
      description: props.formData.mobileDescription || "",
      error: "",
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: "",
    });
  };

  handleNext = () => {
    if (!this.state.appType) {
      this.setState({
        error: "Please select App Type.",
      });
      return;
    }

    if (!this.state.platform) {
      this.setState({
        error: "Please select Platform.",
      });
      return;
    }

    this.props.updateFormData({
      appType: this.state.appType,
      platform: this.state.platform,
      userLogin: this.state.userLogin,
      adminPanel: this.state.adminPanel,
      paymentGateway: this.state.paymentGateway,
      pushNotification: this.state.pushNotification,
      gpsLocation: this.state.gpsLocation,
      chatSupport: this.state.chatSupport,
      apiIntegration: this.state.apiIntegration,
      mobileDescription: this.state.description,
    });

    this.props.nextStep();
  };

  render() {
    return (
      <div className="container py-4">

        <div className="card shadow border-0">

          <div className="card-header bg-primary text-white">
            <h3 className="mb-0">
              Step 4 : Mobile App Requirements
            </h3>
          </div>

          <div className="card-body">

            <div className="row">

              {/* App Type */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  App Type <span className="text-danger">*</span>
                </label>

                <select
                  className="form-select"
                  name="appType"
                  value={this.state.appType}
                  onChange={this.handleChange}
                >
                  <option value="">Select App Type</option>
                  <option>Business App</option>
                  <option>E-Commerce App</option>
                  <option>Food Delivery App</option>
                  <option>Hospital App</option>
                  <option>School App</option>
                  <option>Booking App</option>
                  <option>Service App</option>
                  <option>Custom App</option>
                </select>
              </div>

              {/* Platform */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Platform <span className="text-danger">*</span>
                </label>

                <select
                  className="form-select"
                  name="platform"
                  value={this.state.platform}
                  onChange={this.handleChange}
                >
                  <option value="">Select Platform</option>
                  <option>Android</option>
                  <option>iOS</option>
                  <option>Both Android & iOS</option>
                </select>
              </div>

              {/* User Login */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  User Login
                </label>

                <select
                  className="form-select"
                  name="userLogin"
                  value={this.state.userLogin}
                  onChange={this.handleChange}
                >
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>

              {/* Admin Panel */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Admin Panel
                </label>

                <select
                  className="form-select"
                  name="adminPanel"
                  value={this.state.adminPanel}
                  onChange={this.handleChange}
                >
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>

              {/* Payment Gateway */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Payment Gateway
                </label>

                <select
                  className="form-select"
                  name="paymentGateway"
                  value={this.state.paymentGateway}
                  onChange={this.handleChange}
                >
                  <option>No</option>
                  <option>Yes</option>
                </select>
              </div>

              {/* Push Notification */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Push Notification
                </label>

                <select
                  className="form-select"
                  name="pushNotification"
                  value={this.state.pushNotification}
                  onChange={this.handleChange}
                >
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>

              {/* GPS */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  GPS / Location Tracking
                </label>

                <select
                  className="form-select"
                  name="gpsLocation"
                  value={this.state.gpsLocation}
                  onChange={this.handleChange}
                >
                  <option>No</option>
                  <option>Yes</option>
                </select>
              </div>

              {/* Chat */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Chat Support
                </label>

                <select
                  className="form-select"
                  name="chatSupport"
                  value={this.state.chatSupport}
                  onChange={this.handleChange}
                >
                  <option>No</option>
                  <option>Yes</option>
                </select>
              </div>

              {/* API */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Third Party API Integration
                </label>

                <select
                  className="form-select"
                  name="apiIntegration"
                  value={this.state.apiIntegration}
                  onChange={this.handleChange}
                >
                  <option>No</option>
                  <option>Yes</option>
                </select>
              </div>

              {/* Description */}
              <div className="col-12 mb-3">
                <label className="form-label">
                  App Description / Requirements
                </label>

                <textarea
                  rows="5"
                  className="form-control"
                  name="description"
                  placeholder="Describe your mobile application requirements..."
                  value={this.state.description}
                  onChange={this.handleChange}
                />
              </div>

            </div>

            {this.state.error && (
              <div className="alert alert-danger">
                {this.state.error}
              </div>
            )}

            <hr />

            <div className="d-flex justify-content-between">

              <button
                className="btn btn-outline-secondary"
                onClick={this.props.prevStep}
              >
                Previous
              </button>

              <button
                className="btn btn-primary"
                onClick={this.handleNext}
              >
                Next
              </button>

            </div>

          </div>

        </div>

      </div>
    );
  }
}

export default Step4Mobile;